import PropTypes from 'prop-types'
import React from 'react'
import { FormattedMessage, injectIntl } from 'react-intl'

import { intlShape } from '@/checkout-instore-legacy/i18n/intlShape'
import SummaryCard from './SummaryCard'

const CART_CARD_NUMBER = 1

function CartSummaryCard({
  intl,
  active,
  itemQuantity,
  handleCardClick,
  hover,
  disabled,
}) {
  const title = intl.formatMessage({ id: 'summary.cart.card.cart.title' })
  const content =
    itemQuantity > 0 ? (
      <FormattedMessage
        id="summary.cart.card.cart.content"
        values={{ quantity: itemQuantity }}
      />
    ) : (
      <FormattedMessage
        id="summary.cart.card.cart.empty"
        values={{ quantity: itemQuantity }}
      />
    )
  return (
    <div id="summary-cart-card">
      <SummaryCard
        title={title}
        number={CART_CARD_NUMBER}
        content={content}
        active={active}
        onClick={handleCardClick}
        hover={hover}
        disabled={disabled}
      />
    </div>
  )
}

CartSummaryCard.propTypes = {
  intl: intlShape,
  active: PropTypes.bool,
  itemQuantity: PropTypes.number,
  handleCardClick: PropTypes.func.isRequired,
  hover: PropTypes.bool,
  disabled: PropTypes.bool,
}

export default injectIntl(CartSummaryCard)
